// const BASE_URL = "https://sansaar.ainocular.com/api"
// const BASE_URL_ECOM = "https://ecom.sansaar.ainocular.com/api"
// const BASE_URL_ECOM = "http://localhost:8050/api"

const BASE_URL = "https://sansaar.co.in/api"
const BASE_URL_ECOM = "https://ecom.sansaar.co.in/api"

const apiUrl = {
    auth: {
        login: `${BASE_URL_ECOM}/auth/sign-in`,
        register: `${BASE_URL_ECOM}/auth/sign-up`,
        guestRegister: `${BASE_URL_ECOM}/auth/guest-sign-up`,
        refreshToken: `${BASE_URL_ECOM}/auth/refresh`,
        guestToken: `${BASE_URL_ECOM}/auth/guest-token`,
        forgotPassword: `${BASE_URL_ECOM}/auth/forgot-password`,
        resetPassword: `${BASE_URL_ECOM}/auth/reset-password`,
        // logout: `${BASE_URL}/v1/auth/logout`
    },
    collection: {
        getAll: `${BASE_URL}/v1/collection/all`,
        getMaterials: (collectionId) => `${BASE_URL}/v1/collection/get-materials/${collectionId}`,
        getTrending: `${BASE_URL}/v1/collection/trending`
    },
    contactUs: `${BASE_URL}/v1/util/contact-form`,
    store: `${BASE_URL}/v1/store/get-all`,
    search: (searchTerm) => `${BASE_URL}/v1/util/search?q=${searchTerm}`,
    inspiredLiving: (articleType) => `${BASE_URL}/v1/article/by-type?type=${articleType}`,
    inspiredLivingSearch: (articleType, searchTerm) => `${BASE_URL}/v1/article/search?type=${articleType}&q=${searchTerm}`,
    // ecom
    shop: {
        getAllSKUs: (pageNo, pageSize, direction, orderBy, categoryName, filters) => `${BASE_URL_ECOM}/sku/filter?page=${pageNo}&pageSize=${pageSize}&direction=${direction}&orderBy=${orderBy}&categoryName=${filters.category.length > 0 ? (filters.category).join(',') : '' || categoryName}&collectionName=${filters.collectionName.length > 0 ? (filters.collectionName).join(',') : ''}&size=${filters.size.length > 0 ? (filters.size).join(',') : ''}&design=${filters.designs.length > 0 ? (filters.designs).join(',') : ''}&fabType=${filters.fabrics.length > 0 ? (filters.fabrics).join(',') : ''}&minPrice=${filters.priceRange[0]}&maxPrice=${filters.priceRange[1]}&threadCount=${filters.threadCounts.length > 0 ? (filters.threadCounts).join(',') : ''}`,
        getAllTimeFav: `${BASE_URL_ECOM}/sku/all-time-favorite`,
        getCollectionsList: `${BASE_URL_ECOM}/collection/get-list`,
        getCategoryList: `${BASE_URL_ECOM}/category/get-list`,
        getFilterOptions: `${BASE_URL_ECOM}/sku/filter-option`,
        search: (searchTerm, page, pageSize) => `${BASE_URL_ECOM}/sku/search?q=${searchTerm}&page=${page}&pageSize=${pageSize}`,
    },
    product: {
        getSKUDetailsBySlug: (slug) => `${BASE_URL_ECOM}/sku/by-slug/${slug}`,
        getSKUDetails: (skuId) => `${BASE_URL_ECOM}/sku/get-by-id?id=${skuId}`,
        getCollectionDetails: (collectionId) => `${BASE_URL_ECOM}/collection/get-detail?id=${collectionId}`,
        getCategoryDetails: (categoryId) => `${BASE_URL_ECOM}/category/get-detail?id=${categoryId}`,
        getFeaturedProducts: `${BASE_URL_ECOM}/sku/feature-product`,
    },
    cart: {
        getCart: `${BASE_URL_ECOM}/cart/get-cart`,
        updateCart: `${BASE_URL_ECOM}/cart/add-cart`,
        applyRemoveCouponCart: (coupon) => `${BASE_URL_ECOM}/cart/apply-coupon/${coupon}`,
        cartCheckout: `${BASE_URL_ECOM}/cart/order`,
        getWishlist: `${BASE_URL_ECOM}/user/wishlist`,
        addRemoveFromWishlist: (skuId) => `${BASE_URL_ECOM}/user/wishlist/${skuId}`,
        getCouponList: `${BASE_URL_ECOM}/cart/coupons`,
        paymentVerification: `${BASE_URL_ECOM}/cart/verifyPayment`,
        deliveryStatus: (pinCode) => `${BASE_URL_ECOM}/cart/check-delivery-pincode/${pinCode}`
    },
    address: {
        getAddAddress: `${BASE_URL_ECOM}/user/address`,
        updateAddress: (addressId) => `${BASE_URL_ECOM}/user/address/${addressId}`,
        deleteAddress: (addressId) => `${BASE_URL_ECOM}/user/address/${addressId}`,
        makeAddDefault: (addressId) => `${BASE_URL_ECOM}/user/address/default/${addressId}`,
    },
    profile: {
        getProfile: `${BASE_URL_ECOM}/user/profile`,
        updateProfile: `${BASE_URL_ECOM}/user/profile`
    },
    orderDetails: {
        getOrderDetails: `${BASE_URL_ECOM}/user/order/my-orders`,
    }
};

export default apiUrl;